<template>
  <BaseDialogForm
    v-model="showApiTokenForm"
    :title="`Add ${configurationModule.apiTokenPlural}`"
    :nonFieldErrors="formErrors.non_field_errors"
    maxWidth="500"
  >
    <template #actions>
      <PrimaryButton
        id="apiTokenSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-form v-model="isValid" ref="apiTokenForm" :key="formCount">
        <v-row class="ma-0">
          <v-col cols="12">
            <InputField
              id="name"
              name="name"
              label="Name"
              :required="true"
              v-model="apiTokenDetails.name"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { configurationModule } from "@/utils/moduleMapping";
export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configurationModule,
      isValid: true,
      apiTokenDetails: {},
      formErrors: {},
      formCount: 0,
    };
  },
  computed: {
    showApiTokenForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
      } else {
        this.resetForm();
        this.formErrors = {};
      }
    },
  },
  methods: {
    resetForm() {
      this.apiTokenDetails = {};
      this.$refs.apiTokenForm.reset();
    },
    submitForm() {
      const payload = { ...this.apiTokenDetails };
      this.$api.apiToken
        .createApiTokenObject(payload)
        .then((res) => {
          bus.$emit("showToastMessage", {
            message: "Api Token successfully created",
            color: "success",
          });
          this.$emit("refreshList");
          this.$emit("apiTokenKey", res.data);

          this.showApiTokenForm = false;
        })
        .catch((err) => {
          this.formErrors = err.data;
        });
    },
  },
};
</script>

